import { render } from "./ModalNuovaRichiesta.vue?vue&type=template&id=58a34f6b&scoped=true"
import script from "./ModalNuovaRichiesta.vue?vue&type=script&lang=js"
export * from "./ModalNuovaRichiesta.vue?vue&type=script&lang=js"

import "./ModalNuovaRichiesta.vue?vue&type=style&index=0&id=58a34f6b&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_ambient/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a34f6b"]])

export default __exports__